import { render } from "./ExternalFormatModalImport.vue?vue&type=template&id=2120f6ef"
import script from "./ExternalFormatModalImport.vue?vue&type=script&lang=js"
export * from "./ExternalFormatModalImport.vue?vue&type=script&lang=js"

import "./ExternalFormatModalImport.vue?vue&type=style&index=0&id=2120f6ef&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__